package co.maytes.standupbot.dashboard.components.feedback

import androidx.compose.runtime.Composable
import co.maytes.standupbot.dashboard.components.widgets.Button
import co.maytes.standupbot.dashboard.components.widgets.ButtonVariant
import co.maytes.standupbot.dashboard.styles.Palette
import co.maytes.standupbot.dashboard.styles.Spacing
import co.maytes.standupbot.dashboard.styles.Typography
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.components.text.SpanText

/**
 * Full-page "not found" screen. Use for route-level 404s (resource missing
 * or SPA fallback on unknown path). For inline fetch errors prefer
 * [ErrorState] or [ApiErrorView].
 */
@Composable
fun NotFoundScreen(
    title: String = "We couldn't find that page",
    message: String = "The page you're looking for doesn't exist or you don't have access.",
    primaryLabel: String? = "Back to standups",
    onPrimary: (() -> Unit)? = null,
) {
    Box(
        modifier = Modifier
            .fillMaxWidth()
            .padding(topBottom = Spacing.x3l)
            .styleModifier { property("text-align", "center") },
        contentAlignment = Alignment.TopCenter,
    ) {
        Column(horizontalAlignment = Alignment.CenterHorizontally) {
            SpanText(
                text = "404",
                modifier = Modifier
                    .fontSize(Typography.display.size)
                    .fontWeight(Typography.display.weight)
                    .color(Palette.textTertiary),
            )
            SpanText(
                text = title,
                modifier = Modifier
                    .margin(top = Spacing.md)
                    .fontSize(Typography.h2.size)
                    .fontWeight(Typography.h2.weight)
                    .color(Palette.textPrimary),
            )
            SpanText(
                text = message,
                modifier = Modifier
                    .margin(top = Spacing.xs)
                    .fontSize(Typography.body.size)
                    .color(Palette.textSecondary),
            )
            if (primaryLabel != null && onPrimary != null) {
                Box(modifier = Modifier.margin(top = Spacing.lg)) {
                    Button(label = primaryLabel, variant = ButtonVariant.Primary, onClick = onPrimary)
                }
            }
        }
    }
}
